import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import i18n from './components/i18n';
import './styles-v2/App.css';
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import AboutUsAndSectors from "./components/AboutUsAndSectors";
import ServiciosTarjetas from "./components/ServiciosTarjetas";
import Stats from "./components/Stats";
import PartnerLogos from "./components/PartnerLogos";
import Noticias from "./components/Noticias";
import Contacto from "./components/Contacto";
import MiContacto from "./components/Mi-contacto";
import { Analytics } from '@vercel/analytics/react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { HelmetProvider } from 'react-helmet-async';
import {useTranslation} from "react-i18next";


const RootRedirect = () => {
    // i18n.language ya contiene el idioma detectado por el plugin LanguageDetector
    const detectedLng = i18n.language?.split('-')[0] || 'es';
    const supportedLangs = ['es', 'en'];
    const finalLng = supportedLangs.includes(detectedLng) ? detectedLng : 'es';
    useTranslation();
    return <Navigate to={`/${finalLng}`} replace />;
};


const MainSite = ({ isScrolled }) => {
    const { lang } = useParams();

    useEffect(() => {
        // Sincroniza el idioma de la URL con i18next
        if (lang && i18n.language !== lang) {
            i18n.changeLanguage(lang);
        }
    }, [lang]);


    useEffect(() => {
        const observerElements = document.querySelectorAll('.hidden');
        const observerOptions = { root: null, threshold: 0.1 };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('show');
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);

        observerElements.forEach(el => observer.observe(el));
        return () => observer.disconnect();
    }, [lang]);

    return (
        <div className="app-container">
            <Home className="hidden" />
            <AboutUsAndSectors className="hidden" />
            <ServiciosTarjetas className="hidden" />
            <Stats className="hidden" />
            <PartnerLogos className="hidden" />
            <Noticias className="hidden" />

            <Contacto className="hidden" />
            <MiContacto />

        </div>
    );
};

const App = () => {
    const [isScrolled, setIsScrolled] = useState(false);

    // Tu lógica de Scroll original
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <HelmetProvider>
            <Router>
                {/* El Navbar queda fuera de las rutas para que sea global */}
                <Navbar isScrolled={isScrolled} />

                <Routes>
                    {/* Redirección inicial: dominio.com -> dominio.com/es */}
                    <Route path="/" element={<RootRedirect />} />

                    {/* Ruta dinámica: dominio.com/es o dominio.com/en */}
                    <Route path="/:lang" element={<MainSite isScrolled={isScrolled} />} />

                    {/* Si alguien entra a una ruta que no existe, volvemos a /es */}
                    <Route path="*" element={<Navigate to="/es" replace />} />
                </Routes>

                <Analytics />
            </Router>
        </HelmetProvider>
    );
};

export default App;